import React from 'react';
import { IRole } from 'shared/models/api/models';

export interface ITabProps {
    title: string,
    url: string,
    component?: any
}

interface ITabButtonsProps {
    tabs: ITabProps[],
    selected: ITabProps | null,
    onSelected?: (tab: ITabProps) => void,
    userRoles: IRole[]
}

export const TabButtons = (props: ITabButtonsProps) => {
    const tabClicked = (tab: ITabProps) => {
        if (props.onSelected) {
            props.onSelected(tab)
        }
    };

    return (<>
        {props.tabs.map(tab =>
            <div key={tab.title}
                className={"tab-button" + (props.selected?.title === tab.title ? " selected" : "")}
                onClick={() => tabClicked(tab)}>
                {tab.title}
            </div>
        )}
    </>);
};